import { meta } from './meta';

export const SUPPORT_PROVIDERS = ['youtube', 'vimeo', 'url'];
export const DEFAULT_VIDEO_HEIGHT = 1080;
export const DEFAULT_VIDEO_WIDTH = 1920;
export const VIDEO_ASPECT_RATIO = DEFAULT_VIDEO_HEIGHT / DEFAULT_VIDEO_WIDTH;
export const ARROWS_CONTAINER_HEIGHT = 68;
export const MOBILE_BREAKPOINT = 440;
export const IMAGE_OR_VIDEO_SLIDE_MIN_HEIGHT = '90vh';
export const YOUTUBE_DEFAULT_HEIGHT = 315; // Default YouTube embed height
export const APP_CLASSNAME_PREFIX = `eapp-${meta.appAlias}`;
export const STATIC_IMAGES_URL =
  'https://universe-static.elfsightcdn.com/app-static/slider';
